import { sha256 as nobleSha256 } from '@noble/hashes/sha2'
import { bytesToHex, utf8ToBytes } from '@noble/hashes/utils'

/**
 * Not `crypto.subtle` — that only exists in a secure context, and preview envs are
 * served over plain HTTP, where every call throws.
 */
export function sha256(text: string): string {
  return bytesToHex(nobleSha256(utf8ToBytes(text)))
}
